import React from 'react';
import HeaderLinksContainer from './header-links-desktop.styles';

const DesktopHeaderLinks = () => {
    return (
        <HeaderLinksContainer>
            <ul>
                <li>
                    <a href="#Home">Home</a>
                </li>
                <li>
                    <a href="#Services">Services</a>
                </li>
                <li>
                    <a href="#Portfolio">Portfolio</a>
                </li>
                <li>
                    <a href="#Skills">Skills</a>
                </li>
                <li>
                    <a href="#Pricing">Pricing</a>
                </li>
                <li>
                    <a href="#Contact">Contact</a>
                </li>
            </ul>
        </HeaderLinksContainer>
    );
};

export default DesktopHeaderLinks;
